<template>
  <div id="login" style="min-height: calc(100vh - 20px)" tag="section">
    <div
      v-if="enviroment != 'production'"
      style="background-color: gold; font-weight: 800; text-align: center"
    >
      Ambiente de {{ nomeAmbiente }}
    </div>
    <b-row class="justify-content-center no-gutters">
      <b-col lg="12" class="d-flex align-items-center">
        <b-card no-body class="w-100">
          <b-row class="no-gutters" style="min-height: 100vh">
            <b-col
              lg="6"
              class="bg-cej d-md-flex align-items-center justify-content-center"
            >
              <div class="d-flex align-items-center text-login">
                <div>
                  <b-row class="justify-content-center">
                    <b-col cols="12" lg="12" xl="12">
                      <div>
                        <h2 class="display-5 text-white fw-medium">
                          Portal do Aluno
                        </h2>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-col>
            <b-col
              lg="6"
              class="d-md-flex align-items-center justify-content-center"
            >
              <div class="d-flex align-items-center w-100">
                <div class="p-5 w-100">
                  <b-row class="justify-content-center">
                    <b-col cols="12" lg="9" xl="6">
                      <div class="d-flex mb-4">
                        <img
                          class="m-auto login__logo-img"
                          src="@/assets/images/logo.png"
                          width="300"
                        />
                      </div>
                      <h2 class="font-weight-bold mt-4">
                        {{ $t("GERAL.LOGIN") }}
                      </h2>
                      <input-text
                        ref="email"
                        v-model="form.email"
                        noLabel
                        :label="$t('GERAL.CPF_MATRICULA_ALUNO')"
                        :placeholder="$t('GERAL.CPF_MATRICULA_ALUNO')"
                        @enter="login()"
                        required
                      />
                      <input-text
                        ref="senha"
                        v-model="form.senha"
                        noLabel
                        type="password"
                        :label="$t('GERAL.SENHA')"
                        :placeholder="$t('GERAL.SENHA')"
                        @enter="login()"
                        showPassword
                        required
                      />
                      <b-button
                        variant="primary"
                        size="lg"
                        block
                        class="mt-4"
                        @click="login"
                        >{{ $t("GERAL.LOGIN") }}</b-button
                      >
                      <div class="ml-auto mt-2">
                        <a
                          @click="abrirModal"
                          href="javascript:void(0)"
                          class="link"
                          >{{ $t("GERAL.ESQUECEU_SENHA") }}</a
                        >
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <modal-esqueceu-senha
      :mostrarModal="mostrarModal"
      @fecharModal="fecharModal()"
    />
    <modal-escolher-aluno
      ref="modalEscolherAluno"
      :mostrarModal="mostrarModalEscolherAluno"
      @fecharModal="fecharModalEscolherAluno()"
      @atualizar="redirecionar"
    />
  </div>
</template>

<script>
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import mensagem from "@/common/utils/mensagem";
import helpers from "@/common/utils/helpers";

import InputText from "@/components/inputs/InputText";
import { LOGIN } from "@/store/autenticacao.module";
import ModalEsqueceuSenha from "./components/ModalEsqueceuSenha";
import ModalEscolherAluno from "./components/ModalEscolherAluno";

export default {
  name: "Login",
  components: {
    InputText,
    ModalEsqueceuSenha,
    ModalEscolherAluno,
  },
  computed: {
    nomeAmbiente() {
      return process.env.NODE_ENV === 'development'
        ? 'Desenvolvimento'
        : 'Homologação';
    },
  },
  data() {
    return {
      enviroment: process.env.NODE_ENV,
      form: {
        email: process.env.VUE_APP_EMAIL || "",
        senha: process.env.VUE_APP_PASS || "",
      },
      mostrarModal: false,
      mostrarModalEscolherAluno: false,
    };
  },
  methods: {
    validarFormulario() {
      let arValidation = [];
      arValidation.push(this.$refs.email.valid());
      arValidation.push(this.$refs.senha.valid());

      return arValidation.filter((elem) => elem == false).length == 0;
    },
    login() {
      if (!this.validarFormulario()) return;
      this.$store.dispatch(START_LOADING);
      const form = this.form;
      this.$store
        .dispatch(LOGIN, {
          ...form,
          senha: helpers.Encriptar(form.senha),
        })
        .then((data) => {
          if (data.alunosVinculados.length == 1) {
            this.$refs.modalEscolherAluno.selecionarAluno(
              data.alunosVinculados[0]
            );
          } else {
            this.abrirModalEscolherAluno();
          }
        })
        .catch((err) => {
          err.response.data.errors.forEach((element) => {
            element.tipoNotificacao === "Erro" ||
            element.tipoNotificacao === null
              ? mensagem.erro(this.$t("GERAL.ERRO"), element.mensagem)
              : mensagem.warning(this.$t("GERAL.AVISO"), element.mensagem);
          });
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    redirecionar() {
      this.$router.push({ name: "dashboard" });
    },
    abrirModal() {
      this.mostrarModal = true;
    },
    fecharModal() {
      this.mostrarModal = false;
    },
    abrirModalEscolherAluno() {
      this.mostrarModalEscolherAluno = true;
    },
    fecharModalEscolherAluno() {
      this.mostrarModalEscolherAluno = false;
    },
  },
};
</script>
<style>
.login__logo-img {
  width: 250px;
  max-width: 100%;
}
.bg-cej {
  background: url(../../../assets/images/background/login.jpg) no-repeat center
    center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.bg-cej::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 255, 0.3); /* Azul com transparência */
  z-index: 1;
}
.text-login {
  z-index: 99;
}
</style>
